var _module = require('../components/module.js');

/*
strReplace
Replace matching sub string with provided characters
*/
_module.filter('strReplace', function () {
    return function strReplace(str, target, replaceStr) {
        var s = String(str);
        var targetStr = target || '';
        var replaceWithStr = replaceStr || '';

        s = s.replace(targetStr, replaceWithStr);

        return s;
    };
});
